import IconClose from '@assets/icons/close.svg?react';
import { IconButton, useTheme } from '@mui/material';

const CloseButton = ({ closeDialog }: { closeDialog: () => void }) => {
 const th = useTheme();
 return (
  <IconButton
   aria-label="close"
   onClick={closeDialog}
   sx={() => ({
    position: 'absolute',
    right: 8,
    top: 8,
   })}
  >
   <IconClose
    style={{ width: 20, height: 20, color: th.palette.kemek.darkestGray }}
   />
  </IconButton>
 );
};

export default CloseButton;
